import React from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";
import logo from "../assets/logo.png";


const Navbar = () => (
  <nav className="navbar">
    <div className="navbar-left">
      <Link to="/" className="brand-link">
        <img src={logo} alt="Venture Stone Realty Logo" className="logo" />
      </Link>
    </div>

    <div className="links">
      <Link to="/">Home</Link>
      <Link to="/services">Services</Link>
      <Link to="/contact">Contact Us</Link>
    </div>
  </nav>
);

export default Navbar;
